import "./App.css";
import { Outlet } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { UserProvider } from "./context/UserContext.js";

function App() {
  return (
    <div className="app">
      <div className="background-image1"></div>
      <div className="background-image2"></div>
      <div className="outlet-section">
        <UserProvider>
          <Header />
          <Outlet />
          <Footer />
        </UserProvider>
      </div>
    </div>
  );
}

export default App;
